import { useForm } from 'react-hook-form';
import { ListingFormData } from '../types';

/**
 * Manages form state, validation, and value management for listing creation
 * Centralizes React Hook Form logic away from main component
 */
export const useListingForm = (defaultValues?: Partial<ListingFormData>) => {
  return useForm<ListingFormData>({
    mode: 'onTouched',
    reValidateMode: 'onChange',
    defaultValues: {
      title: '',
      type: 'Apartment',
      price: undefined,
      location: '',
      virtualTourUrl: '',
      bedrooms: 1,
      size: undefined,
      bathrooms: 1,
      description: '',
      amenities: [],
      availableFrom: new Date(),
      berRating: '',
      images: {} as FileList,
      videoUrl: '',
      units: [{ title: '', price: undefined }],
      ...defaultValues,
    },
  });
};

export default useListingForm;
